export const carPositionOption = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    searchShow: true,
    searchMenuSpan: 6,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    editBtn:false,
    delBtn: false,
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    column: [{
            label: "产品名称",
            prop: "productName",
            type: "input",
            search: false,
            searchOrder: 1000,
            span: 24,
            rules: [{
                required: true,
                message: "请输入产品名称",
                trigger: "blur"
            }]
        },
        {
            label: "产品值",
            prop: "productValue",
            search: false,
            display: true,
            span: 24,
            rules: [{
                required: true,
                message: "请输入产品值",
                trigger: "blur"
            }]
        },
        {
            label: "兜底类型",
            prop: "fallbackType",
            type: 'select',
            search: false,
            display: true,
            span: 24,
            dicData: [
              {
                label: '直管',
                value: 1,
              },
              {
                label: '代管',
                value: 2,
              },
            ],
            rules: [{
                required: true,
                message: "请选择兜底类型",
                trigger: "blur"
            }]
        }
    ],
}
